(function () {
  'use strict';

  var root = document.getElementById('ing-glossary-root');
  if (!root) return;

  var letters = (root.dataset.letters || '').split(',').filter(Boolean);
  var list = document.getElementById('ing-glossary-list');
  var status = document.getElementById('ing-glossary-status');

  // NOTE: as of the server-side rendering fix, every ingredient entry is
  // already present in this page's HTML (rendered by Liquid, split across the
  // 26 ing-glossary-letter-* snippets) so crawlers/bots never need JS to see
  // the actual content. This file now only handles progressive enhancement:
  // accordion open/close, disabling A-Z nav links for letters with zero
  // entries, setting the ingredient-count status text, and fetching the
  // per-letter JSON assets purely to build the DefinedTermSet JSON-LD
  // structured-data payload. None of this gates content visibility — the
  // page works fully with JavaScript disabled.

  function enhanceNavAndStatus() {
    var entryCount = list.querySelectorAll('.ing-glossary__entry').length;
    if (status) status.textContent = entryCount + ' ingredients to explore.';

    document.querySelectorAll('[data-letter-link]').forEach(function (link) {
      var letter = link.getAttribute('data-letter-link');
      var section = document.getElementById('letter-' + letter.toLowerCase());
      if (section && section.hidden) link.setAttribute('aria-disabled', 'true');
    });
  }

  function urlFor(letter) {
    // Read the attribute directly rather than via .dataset: the browser's
    // automatic camelCasing of "data-url-a" would give dataset.urlA, not the
    // dataset['url' + letter] lookup below it, so bracket-notation access
    // against .dataset always missed and every fetch silently failed.
    return root.getAttribute('data-url-' + letter.toLowerCase());
  }

  function injectStructuredData(items) {
    var ld = {
      '@context': 'https://schema.org',
      '@type': 'DefinedTermSet',
      name: document.title || 'Ingredients Glossary',
      hasDefinedTerm: items.map(function (item) {
        return {
          '@type': 'DefinedTerm',
          name: item.display_name,
          alternateName: item.inci_name || undefined,
          description: item.definition || undefined,
          inDefinedTermSet: undefined
        };
      })
    };
    // strip undefined keys so the JSON-LD stays clean
    ld.hasDefinedTerm.forEach(function (term) {
      Object.keys(term).forEach(function (key) {
        if (term[key] === undefined) delete term[key];
      });
    });
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'ing-glossary-jsonld';
    script.textContent = JSON.stringify(ld);
    document.head.appendChild(script);
  }

  function openLetter(section, moveFocus) {
    var letter = section.dataset.letter;
    var trigger = section.querySelector('.ing-glossary__letter-trigger');
    var panel = section.querySelector('.ing-glossary__letter-panel');

    list.querySelectorAll('.ing-glossary__letter.is-open').forEach(function (openSection) {
      if (openSection !== section) closeLetter(openSection);
    });

    document.querySelectorAll('[data-letter-link]').forEach(function (link) {
      var active = link.dataset.letter === letter;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });

    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    section.classList.add('is-open');
    if (moveFocus) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function closeLetter(section) {
    section.classList.remove('is-open');
    section.querySelector('.ing-glossary__letter-trigger').setAttribute('aria-expanded', 'false');
    section.querySelector('.ing-glossary__letter-panel').hidden = true;
  }

  list.addEventListener('click', function (event) {
    var letterButton = event.target.closest('.ing-glossary__letter-trigger');
    var entryButton = event.target.closest('.ing-glossary__entry-trigger');

    if (letterButton) {
      var section = letterButton.closest('.ing-glossary__letter');
      if (letterButton.getAttribute('aria-expanded') === 'true') closeLetter(section);
      else openLetter(section, false);
    }

    if (entryButton) {
      var body = document.getElementById(entryButton.getAttribute('aria-controls'));
      var expanded = entryButton.getAttribute('aria-expanded') === 'true';
      entryButton.setAttribute('aria-expanded', String(!expanded));
      body.hidden = expanded;
    }
  });

  document.querySelector('.ing-glossary__nav').addEventListener('click', function (event) {
    var link = event.target.closest('[data-letter-link]');
    if (!link) return;
    event.preventDefault();
    // The link's actual attribute is data-letter-link (its value IS the
    // letter), which the browser exposes as dataset.letterLink — not
    // dataset.letter. Reading dataset.letter returned undefined, so
    // .toLowerCase() threw and silently killed this whole handler, which is
    // why clicking a letter did nothing at all.
    var section = document.getElementById('letter-' + link.getAttribute('data-letter-link').toLowerCase());
    if (!section || section.hidden) return;
    openLetter(section, true);
    history.replaceState(null, '', link.getAttribute('href'));
  });

  enhanceNavAndStatus();

  var hashMatch = location.hash.match(/^#letter-([a-z])$/i);
  if (hashMatch) {
    var initial = document.getElementById('letter-' + hashMatch[1].toLowerCase());
    if (initial && !initial.hidden) openLetter(initial, false);
  }

  // JSON-LD is a nice-to-have enhancement, fetched after the fact; it does
  // not gate anything the user sees, so a fetch failure here is harmless.
  var allItems = [];
  Promise.all(letters.map(function (letter) {
    return fetch(urlFor(letter), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (items) {
        if (items && items.length) allItems = allItems.concat(items);
        return null;
      })
      .catch(function () {
        return null;
      });
  })).then(function () {
    if (allItems.length) injectStructuredData(allItems);
  });
})();
